<template>
    <modal-component
      :active="active"
      @cancel="close"
      @hdlOnClick="updateStatus"
      :textSave="item.enabled ? 'Desactivar' : 'Activar'"

      titleModal="Cambio de estatus"
      :disabled="loading"
      :loader="loading"
    >
      <div class="has-text-confirmation">
        ¿Estás seguro de {{ item.enabled ? 'desactivar' : 'activar' }} el módulo <span>"{{item.name}}"</span>?
      </div>
    </modal-component>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import mixins from '../../../mixins/formats'

export default {
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  mixins: [mixins],
  props: {
    item: {
      type: Object
    },
    active: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      detault: () => {}
    },
    reload: {
      type: Function,
      detault: () => {}
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions(['updateCmsContentStatus']),
    async updateStatus () {
      this.loading = true
      const response = await this.updateCmsContentStatus(this.item.id)
      if (response.success) {
        await this.reload()
        this.close()
      }
      this.loading = false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany.financialCompany
    })
  }
}
</script>
